// extracted by mini-css-extract-plugin
module.exports = {"Select":"E4vloHcv84CWN1LSXY-C3"};